<template>
  <div class="calendar-master">
      <div>
        <p>{{yearToDisplay}}</p>
        <p class="month-wrap">
            <button @click="monthBack">&larr;</button>
            {{allMonths[monthIndexToDisplay]}}
            <button @click="monthNext">&rarr;</button>
        </p>
        <div class="days-names-wrap">
            <div v-for="(i, idx) in allDaysInWeek" :key="'dayInWeek'+idx">
                {{i}}
            </div>
        </div>
        <div class="calendar-days-wrap">
            <div v-for="(i,idx) in numberOfEmptyDays+numberOfDays" :key="idx+'day'"
                class="day-box"
                :class="{
                    'empty-day':i<=numberOfEmptyDays,
                    'regular-day': i>numberOfEmptyDays,
                    'selected-day':i===dayToDisplay+numberOfEmptyDays
                }"
                @click="selectDay(i)">
                <span v-if="i>numberOfEmptyDays">{{i-numberOfEmptyDays}}</span>
            </div>
        </div>
        <button @click="selectDate()">Потврди</button>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            currentDate: new Date(),
            allMonths: ['Јануар','Фебруар','Март','Април','Мај','Јун','Јул','Август','Септембар','Октобар','Новембар','Децембар'],
            allDaysInWeek: ['Пон','Уто','Сре','Чет','Пет','Суб','Нед'],
            yearToDisplay: new Date().getFullYear(),
            monthIndexToDisplay: new Date().getMonth(),
            dayToDisplay: new Date().getDate(),
            numberOfDays: new Date(new Date().getFullYear(), new Date().getMonth()+1, 0).getDate(),
            numberOfEmptyDays: (new Date(new Date().getFullYear(), new Date().getMonth(), 1).getDay()+6)%7
        }
    },
    methods:{
        resetAllData(){
            this.yearToDisplay= new Date(this.currentDate).getFullYear();
            this.monthIndexToDisplay= new Date(this.currentDate).getMonth();
            this.dayToDisplay= new Date(this.currentDate).getDate();
            this.numberOfDays= new Date(this.yearToDisplay, this.monthIndexToDisplay+1, 0).getDate();
            this.numberOfEmptyDays= (new Date(this.yearToDisplay, this.monthIndexToDisplay, 1).getDay()+6)%7;
        },
        monthBack(){
            this.currentDate.setDate(1);
            this.currentDate.setMonth(this.monthIndexToDisplay-1);
            this.resetAllData();
        },
        monthNext(){
            this.currentDate.setDate(1);
            this.currentDate.setMonth(this.monthIndexToDisplay+1);
            this.resetAllData();
        },
        selectDay(i){
            if(i>this.numberOfEmptyDays){
                this.dayToDisplay=i-this.numberOfEmptyDays;
                this.currentDate.setDate(i-this.numberOfEmptyDays);
            }
        },
        selectDate(){
            let date= new Date(this.currentDate);
            this.$emit("close", date);
        }
    }
}
</script>

<style lang="scss" scoped>
    .calendar-master{
        @include PopupStyling();
        >div{
            position: relative;
            height: 90%;
            >p{
                text-align: center;
            }
            button{
                font-weight: 700;
                padding: 5px 30px;
                border: 2px solid #000;
                background-color: #fff;
                border-radius: 10px;
                &:hover{
                    opacity: 0.7;
                    cursor: pointer;
                }
            }
            >button{
                width: 300px;
                display: block;
                margin: 5px auto;
            }
        }
        .month-wrap{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .days-names-wrap{
            display: flex;
            width: 490px;
            >div{
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
                margin: 10px;
                border-radius: 10px;
                width: 30px;
                height: 15px;
            }
        }
        .calendar-days-wrap{
            display: flex;
            flex-wrap: wrap;
            width: 490px;
        }
        .day-box{
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            margin: 10px;
            border-radius: 10px;
            width: 30px;
            height: 30px;
        }
        .empty-day{
            opacity: 0;
        }
        .regular-day{
            background-color: lightgrey;
            &:hover{
                cursor: pointer;
                opacity: 0.7;
            }
        }
        .selected-day{
            background-color: #555;
            color: #fff;
            border-radius: 9999px;
            &:hover{
                opacity: 1;
            }
        }
    }
    @media only screen and (max-width: 850px) {
        .calendar-master{
            >div{
                font-size: 0.9rem;
            }
            .days-names-wrap{
                width: 350px;
                >div{
                    padding: 10px;
                    margin: 5px;
                    width: 20px;
                    height: 10px;
                }
            }
            .calendar-days-wrap{
                width: 350px;
            }
            .day-box{
                padding: 10px;
                margin: 5px;
                width: 20px;
                height: 20px;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        .calendar-master{
            >div{
                padding: 10px;
            }
        }
    }
</style>